import {makeApiCall} from "../../../../Api/makeApiCall";

const getArchiveBucket = () => `spins-edp-${process.env.REACT_APP_ENV}-archive`;
const getRetailerArchivePath = (archiveRetailerId) => `p_data=sales/p_retailer_id=${archiveRetailerId}`;

const asList = (response) => Array.isArray(response) ? response : [];

const listGcsFiles = (url) =>
    makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/listGcsFiles?url=${encodeURIComponent(url)}`).then(asList);

export const listArchiveFtpFolders = (archiveRetailerId) =>
    makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/listDirectories/?bucket=${getArchiveBucket()}&subdirectory=${encodeURIComponent(getRetailerArchivePath(archiveRetailerId))}`)
        .then(asList);

const findInFolders = (retailerArchiveUrl, folders, filename) =>
    Promise.all(folders.map(folder => listGcsFiles(`${retailerArchiveUrl}/${folder}/${filename}`)))
        .then(results => results.flat().find(file => file.fileName === filename));

export async function findArchiveFiles(archiveRetailerId, archiveFilenames, folders) {
    if (archiveFilenames.length === 0) {
        return [];
    }
    const retailerArchiveUrl = `gs://${getArchiveBucket()}/${getRetailerArchivePath(archiveRetailerId)}`;
    const directMatches = await Promise.all(archiveFilenames.map(filename => findInFolders(retailerArchiveUrl, folders, filename)));

    const hasMissingFiles = directMatches.some(file => !file);
    const fallbackFilesByName = hasMissingFiles
        ? Object.fromEntries((await listGcsFiles(retailerArchiveUrl)).map(file => [file.fileName, file]))
        : {};

    return archiveFilenames
        .map((filename, index) => directMatches[index] || fallbackFilesByName[filename])
        .filter(Boolean)
        .map(({fileName, blobName}) => ({filename: fileName, blobName}));
}
